import { useState, type InputHTMLAttributes } from 'react'

import './password.css'

export function PasswordInput(props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const [visible, setVisible] = useState(false)
  const label = visible ? 'Ocultar senha' : 'Mostrar senha'
  return (
    <div className="password-field">
      <input {...props} type={visible ? 'text' : 'password'} />
      <button className="password-toggle" type="button" aria-label={label} title={label}
        aria-controls={props.id} disabled={props.disabled} onClick={() => setVisible(!visible)}>
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
          <circle cx="12" cy="12" r="3" />
          {visible && <path d="m3 3 18 18" />}
        </svg>
      </button>
    </div>
  )
}
